import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from 'react';
const OverlayContainerContext = /*#__PURE__*/ createContext({
    container: null
});
/**
 * Confines overlays to `element` instead of `document.body`.
 *
 * Deliberately a context of its own rather than a field on the overlay context value: the element
 * changes when a bounded surface mounts, and anything volatile on the overlay context re-renders
 * every consumer in the app (ANCR-4319).
 */ export function OverlayContainerProvider(param) {
    let { element, children } = param;
    const value = useMemo(()=>({
            container: element
        }), [
        element
    ]);
    return /*#__PURE__*/ _jsx(OverlayContainerContext.Provider, {
        value: value,
        children: children
    });
}
export function useBottomSheetContainer() {
    return useContext(OverlayContainerContext);
}
